import React from 'react'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack'

function EcommerceLanguageFields({ handleChange, values, errors, touched }) {
  return (
    <>
      <Stack direction="row" spacing={15} paddingTop={3}>
        <TextField
          id="outlined-basic"
          label="Italiano"
          variant="outlined"
          name="ecommerce_italiano"
          onChange={handleChange}
          value={values.ecommerce_italiano}
          error={touched.ecommerce_italiano && Boolean(errors.ecommerce_italiano)}
          helperText={touched.ecommerce_italiano && errors.ecommerce_italiano}
          size={'small'}
          fullWidth
          autoComplete="off"
        />
      </Stack>
      <Stack direction="row" spacing={15} paddingTop={3}>
        <TextField
          id="outlined-basic"
          label="Inglese"
          variant="outlined"
          name="ecommerce_inglese"
          onChange={handleChange}
          value={values.ecommerce_inglese}
          error={touched.ecommerce_inglese && Boolean(errors.ecommerce_inglese)}
          helperText={touched.ecommerce_inglese && errors.ecommerce_inglese}
          size={'small'}
          fullWidth
          autoComplete="off"
        />
      </Stack>
      <Stack direction="row" spacing={15} paddingTop={3}>
        <TextField
          id="outlined-basic"
          label="Tedesco"
          variant="outlined"
          name="ecommerce_tedesco"
          onChange={handleChange}
          value={values.ecommerce_tedesco}
          error={touched.ecommerce_tedesco && Boolean(errors.ecommerce_tedesco)}
          helperText={touched.ecommerce_tedesco && errors.ecommerce_tedesco}
          size={'small'}
          fullWidth
          autoComplete="off"
        />
      </Stack>
      <Stack direction="row" spacing={15} paddingTop={3}>
        <TextField
          id="outlined-basic"
          label="Olandese"
          variant="outlined"
          name="ecommerce_olandese"
          onChange={handleChange}
          value={values.ecommerce_olandese}
          error={touched.ecommerce_olandese && Boolean(errors.ecommerce_olandese)}
          helperText={touched.ecommerce_olandese && errors.ecommerce_olandese}
          size={'small'}
          fullWidth
          autoComplete="off"
        />
      </Stack>
      <Stack direction="row" spacing={15} paddingTop={3}>
        <TextField
          id="outlined-basic"
          label="Danese"
          variant="outlined"
          name="ecommerce_danese"
          onChange={handleChange}
          value={values.ecommerce_danese}
          error={touched.ecommerce_danese && Boolean(errors.ecommerce_danese)}
          helperText={touched.ecommerce_danese && errors.ecommerce_danese}
          size={'small'}
          fullWidth
          autoComplete="off"
        />
      </Stack>
      <Stack direction="row" spacing={15} paddingTop={3} paddingBottom={3}>
        <TextField
          id="outlined-basic"
          label="Polacco"
          variant="outlined"
          name="ecommerce_polacco"
          onChange={handleChange}
          value={values.ecommerce_polacco}
          error={touched.ecommerce_polacco && Boolean(errors.ecommerce_polacco)}
          helperText={touched.ecommerce_polacco && errors.ecommerce_polacco}
          size={'small'}
          fullWidth
          autoComplete="off"
        />
      </Stack>
    </>
  )
}

export default EcommerceLanguageFields
